export const TableColumn = ({children, ...rest}) => {
    
    return (
        <th {...rest}>
            {children}
        </th>
    )
}